<script>
import { fade } from 'svelte/transition';  // REMOVE?
import coreEmoji from "./coreEmoji.js"
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { remove } from 'svelte-awesome/icons';

import Icon from 'svelte-awesome';
import {supabase} from "./supabaseClient"
import { MaterialApp,  Button} from 'svelte-materialify';
import { EmojiButton } from '@joeattardi/emoji-button';

import sentimentColourScale from "./sentimentColourScale"

export let currentAttendee;
export let attendees;
export let moods;
export let board;
export let mode;
export let instance;
export let selectedEmoji;
let moodReason=''
let editReason = false
$: currentAttendeeMood = currentAttendee ? moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == currentAttendee.id)[0] : '';

let emojiCategories = Array.from(new Set(coreEmoji.map(e => e.Category)))

$: currentInstanceSentiment = instance ? Number.parseFloat(instance.avg_sentiment_score).toFixed(1).toString() : ''

// Setup Channel to broadcast Mood Events
var urlParams =   new URLSearchParams(window.location.search)
let boardAccessKey = urlParams.get('accessKey')
var boardChannel = supabase.channel(boardAccessKey)
 boardChannel.on('broadcast', { event: '*' }, (payload) => {
        ;
        // if (payload.event == 'moodUpdate') {
        //   console.log('New Mood Update')
        //   updateMoodsArray (payload.payload.moodData)
        //   get_board_instances ()
        //   beep()
        // } else if (payload.event == 'attendeeUpdate') {
        //   console.log('Update Attendees')
        //   getAttendees()
        // } else if (payload.event == 'instanceUpdate') {
        //   get_board_instances()
        // }
      })
      .subscribe()


function emojiInCategories(category) {
  return coreEmoji.filter(e => e.Category == category)
}

const handleConfirmMood = async () => {
  mode = 'SELECTED_MOOD'
  updateMood()
  selectedEmoji = []
  moodReason = ''
}

const handleClearMood = async () => {
  selectedEmoji = []
  moodReason=''
  updateMood()
}

function getSentimentColourCode (sentiment) {
  if (Number.parseFloat(sentiment)) {
    var sentimentFixed = Number.parseFloat(sentiment).toFixed(1)
    return sentimentColourScale.filter(a => a.sentiment == sentimentFixed)[0].colour_code
  } else {
    return 'green'
}
}


function getSentimentBarWidth (score) {
  return (Math.abs(score)*2) * 100
}

function getEmojiStyle (noChars) {
  switch (true) {
    case noChars == 1:
      return 'font-size: 46px; line-height:48px'
      break;
    case noChars < 5:
      return 'font-size:28px; line-height:30px;'
      break;
    case noChars < 13:
      return 'font-size:14px; line-height:16px;'
      break;
    case noChars < 21:
      return 'font-size:10px; line-height:12px;'
      break;
    case noChars < 31:
      return 'font-size:6px; line-height:8px;'
      break;
    default:
      return 'font-size:' + 60 / noChars + 'px; line-height:34px;'
  }
}

const handleClickEmoji = async (event) => {
  let emoji = event.target.innerText;
  selectedEmoji = [...selectedEmoji,emoji]
  updateMood()

}

const handleClickSelectedEmoji = async () => {
  var index = selectedEmoji.indexOf(event.target.innerText)
  if (index !== -1) {
    selectedEmoji.splice(index,1)
    selectedEmoji = selectedEmoji // trigger reactivity
  }

  updateMood()
}

const updateMood = async () => {
  let moodData =  {
    _instance_id: instance.id,
    _mood: selectedEmoji,
    _attendee_id: currentAttendee.id,
    _board_id: board.id,
    _reason: moodReason,
    _help_required: '',
    _instance_date: instance.date
  }

  // Save or update Mood record
  if(moodData._instance_id === 'placeholder-today') {
    moodData._instance_id = null;    // Remove the placeholder id.
  }
  let { data, error } = await supabase
  .rpc('set_mood', moodData)
  if (error) console.error(error)
  else console.log(data)

  // Broadcast new mood to other users on the board.
  boardChannel.send({type: 'broadcast', event: 'moodUpdate', payload: { moodData}})


  // Check mood type
  let moodType = "unknown";
  if (moodData._giphy_url && moodData._giphy_url.trim() !== "") {
      moodType = "gif"; // Exclusive type
    } else {
      const types = [];
      if (moodData._mood && moodData._mood.length > 0) {
        types.push("emoji");
      }
      if (moodData._mood_stickers && moodData._mood_stickers.length > 0) {
        types.push("sticker");
      }

      // Join types if both present
      if (types.length > 0) {
        moodType = types.join("+"); // e.g. "emoji+sticker"
      }
    }

  // Log event to Google Analytics
  if (typeof gtag !== 'undefined') {
        gtag('event', 'mood_submit', {
          mood_type: moodType,
          mood_source: 'mobile'
        });
    }

}
 

const handleUpdateMood = async (event) => {
    mode = 'SELECT_MOOD';
}

// Custom Emoji Picker
const picker = new EmojiButton({
  // style: 'twemoji',
  autoHide: true,
  categories: ['smileys','people','animals','food','activities','travel','objects','symbols']
});

picker.on('emoji', selection => {
  selectedEmoji = [...selectedEmoji,selection.emoji]
  updateMood()
});

function showEmojiPicker() {
  const trigger = document.querySelector('#emoji-trigger');
   picker.togglePicker(trigger);
}

function doneEditingReason() {
  editReason = false;
    mode = 'SELECTED_MOOD'
  updateMood()
}

function handleSelectAttendee(attendee) {
  currentAttendee = attendee
  mode = 'SELECT_MOOD'
}
</script>
<svelte:head>
  <!-- prevent zooming on input focus -->
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"/>
</svelte:head>


<div class="boardSentiment" style="width:100%; height: 2%; background-color:#fafafa;" title="{instance? instance.avg_sentiment_score : '' }">
  <div style="height:10px;  transition:width 2s; background-color:{getSentimentColourCode(currentInstanceSentiment)}; width:{instance ? getSentimentBarWidth(instance.avg_sentiment_score): 0}%;"></div>
</div>

<!-- Container for content -->
<div class="mainContent">
  <!-- Preview board -->
  {#if mode != 'SELECT_MOOD'}
    <div class="previewBoard" style="">
      <div class="boardScrollingSection" style="Xwidth:{mode == 'SELECTED_MOOD' ? '100%' : (attendees.length / 2) * 140 +'px'}; display:flex; flex-wrap: wrap; height: 100%; place-content: flex-start;justify-content: center;">

        <!-- Display current attendee -->
        <!-- <div class="attendeeCard" on:click={handleUpdateMood}>
          <div class="attendeeMoodBox" >
            {#if currentAttendeeMood && currentAttendeeMood.mood.length > 0 }
              <div class="emojiText" style="{getEmojiStyle(moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == currentAttendee.id)[0].mood.length)}">
              {#each moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == currentAttendee.id)[0].mood as emoji}
                  <div on:click={handleClickSelectedEmoji}>{emoji}</div>
                {/each}

              </div>
              <div class="moodReason">
                {currentAttendeeMood? currentAttendeeMood.reason : ''}
              </div>
            {:else}
              <img src="/images/defaultMoodIcon.png" height="52px" width="52px" alt="default mood icon" style="vertical-align: middle"/>
            {/if}
            </div>
          <div class="attendeeName">  {currentAttendee.name}</div>
        </div> -->

        <!-- Display other attendees -->
        {#if instance}
        {#each attendees as attendee, i}
          {@const attendeeMood = moods.filter(x => x.board_instance_id == instance.id && x.attendee_id == attendee.id)[0]}

          <!-- {#if attendee.id !== currentAttendee.id} -->
            <div class="attendeeCard" on:click={() => handleSelectAttendee(attendee)}>
              <div class="attendeeMoodBox" >
                <!-- {#if moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == attendee.id)[0] } -->
                {#if attendeeMood && (attendeeMood.mood != '' || attendeeMood.giphy_url != '' )}
                  
                  {#if attendeeMood.giphy_url && attendeeMood.gipyurl != ''}
                    <div><img class="giphy-img" src="{attendeeMood.giphy_url}" /></div>
                  {:else}
                    <div class="emojiText" style="{getEmojiStyle(moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == attendee.id)[0].mood.length)}">
                      {moods.filter(x => x.board_instance_id== instance.id && x.attendee_id == attendee.id)[0].mood.join('')}
                    </div>
                    <div class="moodReason">
                      {(attendeeMood) ? attendeeMood.reason : ''}
                    </div>
                  {/if}

                {:else}
                  <img src="/images/defaultMoodIcon.png" height="52px" width="52px" alt="default mood icon" style="vertical-align: middle"/>
                {/if}
                </div>
              <div class="attendeeName"> {attendee.name}</div>
            </div>


          <!-- {/if} -->
        {/each}
        {/if}
      </div>
    </div>
  {/if}

  <!-- Select Mood  -->
  {#if mode == 'SELECT_MOOD'}
  <div class="selectMood">

      <!-- Select Mood header -->
      <div class="selectMoodHeader">
        <div class="boardQuestion">
          What's your Mood Today?
        </div>

        <!-- Selected emoji -->
        <div class="selectedEmojiContainer">
          <div class="selectedEmojiBox">
            {#if selectedEmoji.length == 0}
              <img src="/images/defaultMoodIcon.png" height="48px" width="48px" alt="default mood icon" style="vertical-align: middle"/>
            {:else}
            <div class="selectedEmoji wordwrap" style="{getEmojiStyle(selectedEmoji.length)}">
              {#each selectedEmoji as emoji}
                <div on:click={handleClickSelectedEmoji}>{emoji}</div>
              {/each}
            </div>
            {/if}
          </div>

            <div style="text-align: center; height:60px">
              {#if selectedEmoji.length > 0 }
              <!-- <input  on:focus={e=> {editReason=true}}  on:blur={doneEditingReason} id="moodReasonInut" placeholder="Whys that?" type="text" size="14" bind:value={moodReason} transition:fade="{{ duration: 1000 }}" /> -->
              <div transition:fade="{{ duration: 1000 }}" style="text-align: center">
                <!-- Why's that?<br/> -->
                <textarea id="moodReasonInut" on:focus={e=> {editReason=true;window.scrollTo(0, 0);}}  on:blur={doneEditingReason} maxlength="140" bind:value={moodReason} cols="14" placeholder="Why's that?"style="margin-top: 6px"/>
              </div>
              {/if}
            </div>

            <div class="selectedAttendeeName">{currentAttendee.name}</div>
        </div>

      </div>

      <!-- Select Emoji -->
      <!-- {#if !editReason} -->
        <div class="selectEmoji">
          {#each emojiCategories as emojiCat}
            <div class="emojiCateogry">{emojiCat}</div>
            <div class="emojiCategoryContainer">
            {#each emojiInCategories(emojiCat) as emojiInCat}
              <div class="chooseEmoji" on:click={handleClickEmoji}>{emojiInCat.Emoji}</div>
            {/each}

            </div>
          {/each}
        </div>
      <!-- {/if} -->

      <!-- What's the reason? -->
      <!-- {#if selectedEmoji.length > 0 || currentAttendee.reason != ''}
        <div style="text-align: center;height:38px; ">
          <input on:focus={e=> {editReason=true}}  on:blur={doneEditingReason} id="moodReasonInut" placeholder="Whys that?" type="text" Xsize="14" bind:value={moodReason} transition:fade="{{ duration: 1000 }}" />
        </div>
      {/if} -->
  </div>
  {/if}

</div>


<!-- Footer -->

<div class="selectMoodFooter">
  {#if mode == 'SELECT_MOOD'}
    <Button style="background-color:white; Xwidth: 30%; margin-right: 10px" id="emoji-trigger" on:click={() => showEmojiPicker()}>More 😀</Button>
    <Button class="danger" on:click={handleClearMood} style="background-color:white; Xwidth:20%; margin-right: 10px">Clear&nbsp;<Icon data={remove} scale="1" style="color:red"/>  </Button>
    <Button class="primary" on:click={handleConfirmMood} style="xwidth:40%">Done&nbsp;<Icon data={faCheck} scale="1"/>  </Button>
  {:else if mode=='SELECTED_MOOD'}
    <!-- <Button on:click={handleUpdateMood} class="primary" style="width:80%"> Update my Mood</Button> -->
  {/if}
</div>


<style>
:global(.emoji-picker__wrapper) {z-index: 9999 !important}

.mainContent {display: flex; flex-direction: column; height: 82%}

.previewBoard {Xdisplay: flex; flex-wrap: wrap; margin-left: 4%; margin-right: 4%; margin-top: 10px; overflow-x: scroll; flex-grow: 1; Xmax-height: 280px;}
.attendee {width:88px; margin-bottom: 10px}
.attendeeName{color:var(--blue);font-size: 18px; text-align: center; line-height: 20px}
.emoji {text-align: center; width: 80px}
.defautlMood {text-align: center;}


/* Attendee card */
.attendeeCard {width: 100px; Xheight: 120px; box-shadow: 0px 1px 15px -3px rgba(0,0,0,0.1);margin-right: 12px; background-color: white;
border: 1px solid lightGrey; min-height: 120px; display: flex; flex-direction: column;
}
.attendeeMoodBox {Xheight: 70%; width: 80%; margin-left: auto;margin-right: auto;margin-top: 10%; text-align: center;cursor:pointer; display: flex; justify-content: center; flex-direction: column; align-items: center;}
.emojiText{Xpadding-top: 18px; display: flex; flex-wrap: wrap;justify-content: center;}
.moodReason {  font-family:  'Fresca', sans-serif; color:var(--blue);line-height: 14px; overflow: scroll; text-overflow: ellipsis;}
.attendeeName { font-weight: bold; margin-left: auto;margin-right: auto;width: 80%; text-align: center; margin-bottom:10px; margin-top: auto}

.selectMoodHeader {display:flex; padding-left: 4%; padding-right: 4%; Xbackground-color: #ebebeb; padding-top: 8px; height: 16%}
.boardQuestion {color: var(--blue); font-size: 22px; Xwidth:66%; font-weight: bold; font-size: 22px}
.selectedEmojiContainer {width: 40%; display: flex; flex-direction: column; align-items: center; border: #96969680 solid 1px; background-color: white;height: 160px}
.selectedEmojiBox{  width: 72px;text-align: -webkit-center; height: 72px;display: flex; flex-direction: row; align-items: center;justify-content: center; }
.selectedEmoji {display: flex; flex-wrap: wrap;width: 90px; justify-content: center;}
.selectEmoji { padding-left: 4%; padding-right: 4%; Xbackground-color: #ebebeb;height: 60%; Xheight: 25vh; overflow: scroll}
.giphy-img{height: 60px; width: auto;}
#moodReasonInut{Xheight:34px; font-size: 18px; text-align:center; width: 80%; padding: 0 !important; line-height: 24px;}
.selectedAttendeeName {color:var(--blue);font-size: 18px; text-align: center; line-height: 20px; font-weight: bold}
.current {font-weight: bold !important;}

.emojiCategoryContainer{display: flex; flex-wrap: wrap;display: flex; }
.chooseEmoji{text-align: center; font-size: 30px; border: #96969680 solid 1px; cursor: pointer; width:46px; height: 46px;line-height: 46px;}
.emojiList { overflow-y: auto;  white-space: nowrap;height: 360px; margin-left:20px; margin-right:20px}

.moreEmoji {background-color: #ebebeb; text-align: end;}

.selectMoodFooter {position: fixed; bottom: 0; width: 100%;text-align: center; background-color: white; height:8%; display: flex; justify-content: center; Xbackground-color:#ebebeb; align-items: center;padding-left: 20px;
    padding-right: 20px; }

.wordwrap {
 white-space: pre-wrap;      /* CSS3 */
 white-space: -moz-pre-wrap; /* Firefox */
 white-space: -pre-wrap;     /* Opera <7 */
 white-space: -o-pre-wrap;   /* Opera 7 */
 word-wrap: break-word;      /* IE */
}
</style>
